exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.otras-semanas-disponible-title[data-v-112ab8f5] {\n    text-align: center;\n    font-weight: bold;\n    margin-top: 1rem;\n}\n.otras-semanas-disponible-semana[data-v-112ab8f5] {\n    color: #0871b8;\n}\n", ""]);
